<router-outlet></router-outlet>
<artemis-dialog></artemis-dialog>
